// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IconValuePair_wrapper___tmWe","sm":"IconValuePair_sm__vrxWW","value":"IconValuePair_value__a31Us"};